import {
  getBaseMenuItems,
  type NavigationMenuItemT,
} from "@/app/config/navigation-ssot";

// Re-export menu item type from navigation SSOT to keep one source of truth.
export type MenuItemT = NavigationMenuItemT;

// Base menu items are resolved from SSOT definitions once at module load.
export const MENU_ITEMS: MenuItemT[] = getBaseMenuItems();
